import React from 'react';
import RaisedButton from "material-ui/RaisedButton";
import ActionDelete from "material-ui/svg-icons/action/delete";


export default ({handleClick, onTouchTap}) => {

  var handleTouchTap = (e) => {
    e.stopPropagation();
    if (window.confirm("Radera?")) { 
      if (typeof handleClick !== 'undefined'){
        console.log("handleClick");
        handleClick();
      } else if (typeof onTouchTap !== 'undefined') {
        console.log("onTouchTap");
        onTouchTap();
      }
    }
    else
    {
      console.log("no confirm");
    }
  }

  return (
    <RaisedButton onTouchTap={handleTouchTap}  >
      Radera
    </RaisedButton>
  );
}



// WEBPACK FOOTER //
// ./src/components/Buttons/DeleteButton.jsx